// extracted by mini-css-extract-plugin
export default {"tableMainElem":"Transactions_tableMainElem__gB7rq","viewMainElem":"Transactions_viewMainElem__RLi2A"};